module.exports = __webpack_public_path__ + "static/pic12-95370d755745f52093e1d854ddbaea3e.jpg";